import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useStore } from "../store";
import { getContent, initializeStore } from "../store/actions";

export default function useContent(
  slugPubType,
  slugTitle,
  tabType,
  pathSectionId
) {
  const {
    header,
    tabs,
    toc,
    updates,
    contentSections,
    contentSectionCache,
    drugDetails,
    detailsSectionCache,
    activeDetailsSubSectionIndex,
    activeDetailsSectionIndex,
    transformData,
    referenceData,
    about,
    headerTools,
    subscription,
    ancillaryData,
    metadata,
    multimedia,
    pubTypeLogos,
    workplaceData,
    breadcrumbData,
    isLoading,
    isContentFetching,
    isDetailsSectionFetching,
    hasError,
    errorData,
    userExperience,
    checklist,
    referenceSectionId,
    careInterventionsSectionId,
    isBookmarking,
    isFollowing,
    notification,
    activeSectionIndex,
    userHistory,
    nextSectionHash,
    previousSectionHash,
    lastHash,
    idToSectionMap,
    hasPrintFailed,
    isFullTopicLoading,
    isFullTopicLoaded,
    fullTopicLoadingError,
    isFullTopicPreprocessing,
    fullTopicPreprocessingError,
    loe,
    hasContentFetched,
    cloudinaryToken,
    activeTocItem,
    loadedSection,
    tablesContent,
    styleConfig,
    pdfFiles,
    crossContentReferenceLinks,
  } = useStore();

  const hasData = !(isLoading || hasError);
  const noDataMessage = errorData?.message;
  const contentHidden = errorData?.contentHidden;
  const location = useLocation();
  const { hash } = location;
  const dispatch = useDispatch();

  useEffect(() => {
    initializeStore(dispatch);
    getContent(
      dispatch,
      slugPubType,
      slugTitle,
      tabType,
      hash ? [hash.slice(1)] : undefined,
      pathSectionId
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, slugPubType, slugTitle]);

  return {
    header,
    tabs,
    toc,
    updates,
    contentSections,
    contentSectionCache,
    tablesContent,
    drugDetails,
    detailsSectionCache,
    activeDetailsSubSectionIndex,
    activeDetailsSectionIndex,
    transformData,
    referenceData,
    about,
    headerTools,
    subscription,
    ancillaryData,
    metadata,
    multimedia,
    pubTypeLogos,
    workplaceData,
    breadcrumbData,
    isLoading,
    isContentFetching,
    isDetailsSectionFetching,
    hasData,
    noDataMessage,
    contentHidden,
    userExperience,
    checklist,
    referenceSectionId,
    careInterventionsSectionId,
    isBookmarking,
    isFollowing,
    notification,
    activeSectionIndex,
    userHistory,
    nextSectionHash,
    previousSectionHash,
    lastHash,
    idToSectionMap,
    hasPrintFailed,
    isFullTopicLoading,
    isFullTopicLoaded,
    fullTopicLoadingError,
    isFullTopicPreprocessing,
    fullTopicPreprocessingError,
    loe,
    hasContentFetched,
    cloudinaryToken,
    activeTocItem,
    loadedSection,
    styleConfig,
    pdfFiles,
    crossContentReferenceLinks,
  };
}
